import './App.css';

import React, { useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useMediaQuery } from '@mui/material';

const columns = [
  { field: 'id', headerName: 'ID', width: 60 },
  { field: 'stock_name', headerName: '名称', width: 150 },
  {
    field: 'date',
    headerName: '日期',
    width: 90,
    editable: true,
  },
  {
    field: 'price',
    headerName: 'price',
    width: 100,
    editable: true,
  },
  {
    field: 'one_day_change_pct',
    headerName: '1d',
    width: 100,
    editable: true,
  },
  {
    field: 'seven_day_change_pct',
    headerName: '7d',
    width: 100,
    editable: true,
  },
  {
    field: 'one_month_change_pct',
    headerName: '30d',
    width: 100,
    editable: true,
  },
  {
    field: 'is_cons_3_day_up',
    headerName: '3dup',
    width: 100,
    editable: true,
  },
  {
    field: 'is_cons_3_day_down',
    headerName: '3dsdown',
    width: 100,
    editable: true,
  },
  {
    field: 'is_above_10_day',
    headerName: 'over10ds',
    width: 100,
    editable: true,
  }
];

function App() {

  const [stockData, setStockData] = useState(null);
  const isMobile = useMediaQuery('(max-width:768px)'); // 判断是否为移动端

  // if (isMobile) {
  //   columns.forEach(column => {
  //     column.width = 80; // 设置统一的列宽
  //   });
  // }

  useEffect(() => {
    fetch('https://stockapi.liyunkun.top/')
      .then(response => response.json())
      .then(data => setStockData(data.stock_list))
      .catch(error => console.error('Error fetching stock data:', error))
  }, []);

  return (
    <div className="app">

      <h1 style={{textAlign: 'center'}}>Stock Data</h1>
      
      {stockData ?(
      <div style={{
        display: 'flex',
        justifyContent: 'center', // 水平居中
        alignItems: 'center',     // 垂直居中
        minHeight: '100vh',       // 确保父容器高度撑满视口
      }}>
        <Box className="box" sx={{ height: 600, width: isMobile ? '100%' : '60%', margin: 'auto' }}>
          <DataGrid
            rows={stockData}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: isMobile ? 5 : 10,
                },
              },
            }}
            pageSizeOptions={[5, 10]}
            checkboxSelection
            disableRowSelectionOnClick
            autoHeight // 自动调整表格高度
            disableColumnMenu // 禁用列菜单，减少交互复杂度
          />
        </Box>
      </div>
      ) : (
      <h1 style={{textAlign: 'center'}}>Loading...</h1>
      )}
    </div>
  );
}


export default App;
